export const visit = (vm, at) => {
vm(require("foundations-components/lang/es.lyaml"));
at({ "es": { "placeholder": "marcador de posici\xF3n" } });
};